import { Box, Stack } from '@mui/material';
import { type FC } from 'react';
import { Page } from '../../Page';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
export const RitualTaskEditPageSkeleton: FC = () => {
    return (
        <Page back={true} insetEnabled={false}>
            <Stack height="100%" sx={{ background: 'var(--tgui--secondary_bg_color)' }}>
                <Box
                    sx={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: 'var(--tg-viewport-content-safe-area-inset-top)',
                        display: 'flex',
                    }}
                >
                    <ThemedSkeleton variant="rectangular" width={120} height={20} sx={{ borderRadius: 1 }} />
                </Box>
                <Stack height="100%" paddingLeft="10px" paddingRight="10px" paddingTop="4px" gap={1}>
                    <ThemedSkeleton variant="rectangular" width="100%" height={40} sx={{ borderRadius: 1 }} />
                    <ThemedSkeleton variant="rectangular" width="100%" height={50} sx={{ borderRadius: 1 }} />
                    <ThemedSkeleton variant="rectangular" width="100%" height={40} sx={{ borderRadius: 1 }} />
                </Stack>
            </Stack>
        </Page>
    );
};

